// extracted by mini-css-extract-plugin
module.exports = {"container":"places-module--container--2mnq7"};